// Pomůcka pro 2. definici hlavičky (transponovaná tabulka) u produktů nad MlyGrid / YlyStatsGrid.
// V transponované tabulce jsou veličiny úzké sloupce → potřebují kratší popisy. Struktura
// (skupiny, tsId, normalMode, decimals, unit) zůstává stejná, mění se jen `label`.
//
//   const ROW_GROUPS_T = withShortLabels(ROW_GROUPS, {
//     TEMPAVG_AVG: 'Průměr',
//     TXMAX_GE25: 'Letní ≥ 25',
//     // …tsId, kterým nedáme kratší label, zůstanou s původním
//   }, {
//     'Průměrná teplota': 'Prům. teplota',   // volitelné: přejmenování skupin
//   })
export function withShortLabels(rowGroups, labelByTsId = {}, groupLabelMap = {}) {
  return rowGroups.map(g => ({
    ...g,
    label: groupLabelMap[g.label] ?? g.label,
    rows: g.rows.map(r => ({ ...r, label: labelByTsId[r.tsId] ?? r.label })),
  }))
}
